import { render, staticRenderFns } from "./recruit-evaluate.vue?vue&type=template&id=2edaa2a8&scoped=true"
import script from "./recruit-evaluate.vue?vue&type=script&lang=js"
export * from "./recruit-evaluate.vue?vue&type=script&lang=js"
import style0 from "./recruit-evaluate.vue?vue&type=style&index=0&id=2edaa2a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edaa2a8",
  null
  
)

export default component.exports